export default __webpack_public_path__ + "static/media/sub-cohorts.b355ba11.png";